/* eslint-disable react/jsx-props-no-spreading */
/**
 * Context for Feature App with FA Services
 * @see: https://github.com/volkswagen-onehub/audi-feature-app-hello-world/blob/master/src/context.tsx
 */
import * as React from 'react';
import { LocaleServiceV1 as LocaleService } from '@volkswagen-onehub/locale-service';
import { TrackingServiceV2 as TrackingService } from '@oneaudi/audi-tracking-service';
import { ContentService } from '@volkswagen-onehub/audi-content-service';
import { Logger } from '@feature-hub/logger';
import { I18NServiceV1 as I18NService } from '@oneaudi/i18n-service';
import { QueryCacheService } from '../types';

interface ContextValue {
  localeService: LocaleService;
  i18nService: I18NService;
  logger: Logger;
  trackingService?: TrackingService;
  contentService?: ContentService;
  queryCacheService?: QueryCacheService;
}

export const FeatureServiceContext = React.createContext<ContextValue>({
  localeService: {} as LocaleService,
  i18nService: {} as I18NService,
  logger: console,
  contentService: {} as ContentService,
});
